module.exports = __webpack_public_path__ + "img/gb-whatsapp-backup.a6cd27ec.webp";